import { render, staticRenderFns } from "./classroom-add.vue?vue&type=template&id=a8f63536&scoped=true"
import script from "./classroom-add.vue?vue&type=script&lang=js"
export * from "./classroom-add.vue?vue&type=script&lang=js"
import style0 from "./classroom-add.vue?vue&type=style&index=0&id=a8f63536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f63536",
  null
  
)

export default component.exports